const zhCN = {
  totalTips: 'return `共 <span style="color: #1890FF">${count}</span> 条记录`',
  selectedTips: 'return `已选中 <span style="color: #1890FF">${count}</span> 条`',
  clearSelectedBtn: '清除所有选中'
}
const enUS = {
  totalTips: 'return `<span style="color: #1890FF">${count}</span> records in all`',
  selectedTips: 'return `<span style="color: #1890FF">${count}</span> have been selected`',
  clearSelectedBtn: 'Clear all selected'
}

export default { zhCN, enUS }